<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="my-sm" *ngIf="content">
  <ng-container *ngIf="collapsable && collapsed; else fullContent;">
    <span [ngClass]="textClass">{{this.content | slice:0:this.minLength}}</span>
    <button pButton
            type="button"
            class="p-button-text py-none px-sm bold collapsable-button"
            [label]="'...'"
            (click)="toggleCollapse()" data-testid="toggle-collapse-btn">
    </button>
  </ng-container>
  <ng-template #fullContent>
    <span [ngClass]="textClass">{{this.content}}</span>
    <button pButton *ngIf="collapsable"
            type="button"
            class="p-button-text py-none px-sm bold collapsable-button"
            [label]="('utils.show-less' | translate)"
            (click)="toggleCollapse()" data-testid="toggle-collapse-btn-2">
    </button>
  </ng-template>

</div>


